import { defineStore } from 'pinia'

export interface BreadcrumbItem {
  label: string
  route?: string
  icon?: string
}

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: () => ({
    items: [] as BreadcrumbItem[],
  }),

  getters: {
    breadcrumbItems(state): BreadcrumbItem[] {
      return state.items
    },
  },

  actions: {
    addBreadcrumb(item: BreadcrumbItem) {
      // Evitar duplicados por label
      const exists = this.items.find((b) => b.label === item.label)
      if (!exists) {
        this.items.push(item)
      }
    },

    removeBreadcrumb(label: string) {
      this.items = this.items.filter((item) => item.label !== label)
    },

    resetBreadcrumb() {
      this.items = []
    },

    setBreadcrumb(items: BreadcrumbItem[]) {
      this.items = [...items]
    },
  },
})
